export const classNames = (...classes) => classes.filter(Boolean).join(" ");

export const titleClasses = "text-3xl text-gray-900 font-semibold inline-block";

export const smallTitleClasses = "text-lg leading-6 font-medium text-gray-900";

export const listItemClasses = "px-1 py-2 text-base border-gray-200 w-full";

export const basicLabelClasses = ({ textSize = "text-xs" }) =>
  `font-normal mr-1 relative inline-flex items-center rounded border border-gray-300 px-3 py-0.5 ${textSize} whitespace-nowrap place-self-center`;

export const basicLinkClasses =
  "text-indigo-700 hover:text-indigo-900 cursor-pointer hover:underline";

export const grayLinkClasses =
  "text-gray-600 hover:text-gray-900 cursor-pointer hover:underline";

export const inputTextClasses =
  "block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md";

export const inputTextSmallClasses =
  "py-1 pl-2 pr-10 block w-full shadow-sm text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md";

export const inputTextIsabelClasses =
  "block w-full font-medium sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-isabel-600 border-2 rounded-md";

export const tableRowLinkClasses =
  "cursor-pointer font-bold text-gray-700 hover:text-indigo-900 hover:underline underline-space-2 decoration-2 text-xl underline-offset-2";

export const tableRowNonLinkClasses = "font-bold text-gray-700 text-xl";

export const primaryButtonClasses =
  "text-nowrap cursor-pointer inline-flex items-center px-2 py-1 lg:px-4 lg:py-2 border border-transparent shadow-sm text-xs lg:text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2";

export const primaryButtonSmallClasses =
  "cursor-pointer inline-flex items-center px-4 py-2 border-2 border-gray-300 hover:border-indigo-400 hover:text-indigo-700 shadow-sm text-sm font-medium rounded-lg text-gray-800 bg-white hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500";

export const primaryButtonSmallAlertClasses =
  "cursor-pointer inline-flex items-center px-3 py-2 border-2 border-rose-300 hover:border-rose-400 hover:text-rose-700 shadow-sm text-sm font-medium rounded-lg text-rose-600 bg-rose-50 hover:bg-rose-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500";

export const primaryButtonDisabledClasses =
  "cursor-pointer inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500";

export const primaryButtonDisabledGrayClasses =
  "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 bg-gray-300 focus:outline-none";

export const primaryButtonWhiteClasses =
  "cursor-pointer inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500";

export const subButtonClasses =
  "text-nowrap cursor-pointer inline-flex items-center px-2 py-1 lg:px-4 lg:py-2 border border-indigo-300 text-xs lg:text-sm font-medium border-indigo-300 text-indigo-700 bg-indigo-100 hover:bg-indigo-200 hover:border-indigo-300 hover:z-10 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";

export const subButtonRoundClasses = `${subButtonClasses} shadow-sm rounded-md`;

export const subButtonRoundWhiteClasses = subButtonRoundClasses.replace(
  "bg-indigo-100",
  "bg-white"
);

export const subButtonSmallClasses = `${subButtonClasses} shadow-sm rounded-md`
  .replace("text-sm", "text-xs")
  .replace("px-4 py-2", "px-2 py-1");

export const subButtonRoundAltClasses =
  "cursor-pointer inline-flex items-center px-2 py-1 border border-amber-300 text-sm text-gray-600 bg-amber-100 hover:bg-amber-200 hover:text-gray-700 hover:z-10 focus:z-10 focus:outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500 shadow-sm rounded-md";

export const subButtonGrayClasses =
  "cursor-pointer inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium text-gray-500 bg-gray-100 focus:z-10 focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500";

export const subButtonGrayRoundClasses = `${subButtonGrayClasses} shadow-sm rounded-md select-none`;

export const thirdButtonClasses =
  "cursor-pointer inline-flex items-center px-2 py-1 border border-indigo-300 text-xs font-medium text-indigo-700 bg-indigo-100 hover:bg-indigo-200 hover:border-indigo-300 hover:z-10 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:text-gray-400 disabled:border-gray-300 disabled:bg-gray-100";

export const thirdButtonRoundClasses = `${thirdButtonClasses} shadow-sm rounded-md`;

export const thirdButtonWhiteRoundClasses =
  `${thirdButtonClasses} shadow-sm rounded-md`
    .replace("bg-indigo-100", "bg-white")
    .replace("text-indigo-700", "text-gray-700")
    .replace("border-indigo-300", "border-gray-300")
    .replace("hover:bg-indigo-200", "hover:bg-gray-50");

export const thirdButtonGrayClasses =
  "cursor-pointer inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium text-gray-700 bg-gray-100 focus:z-10 focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500";

export const thirdButtonGrayRoundClasses = `${thirdButtonGrayClasses} shadow-sm rounded-md`;

export const formSidebarClasses =
  "h-full flex flex-col bg-white shadow-xl overflow-y-auto min-h-screen";

export const grayHorizontalRuleClasses =
  "border-0 bg-gray-200 text-gray-200 h-px";

export const badgeClasses = ({
  backgroundColor = "bg-green-100",
  textColor = "text-green-800",
  paddingX = "px-3",
  textSize = "text-sm",
  borderColor = ""
}) =>
  `${
    borderColor !== "" ? `border ${borderColor}` : ""
  } inline-flex items-center ${paddingX} py-0.5 rounded-md ${textSize} font-medium ${backgroundColor} ${textColor}`;

export const avatarOuterClasses = ({
  height = "h-10",
  width = "w-10",
  backgroundColor = "bg-indigo-50"
}) =>
  `inline-flex items-center justify-center rounded-full ${height} ${width} ${backgroundColor}`;

export const avatarInnerClasses = `font-medium leading-none text-gray-500 select-none`;

export const avatarInnerClassesNew = ({
  textColor = "text-white",
  textSize = "text-sm"
}) => `font-semibold leading-none select-none ${textColor} ${textSize}`;

export const headerClasses =
  "px-3 py-3 text-left text-sm font-medium uppercase tracking-wide text-gray-800";

export const grayLabelText = ({
  paddingX = "px-4",
  paddingY = "py-3",
  textSize = "text-xs",
  textColor = "text-gray-700",
  textAlign = "text-left"
}) =>
  `${paddingX} ${paddingY} ${textSize} ${textColor} ${textAlign} font-medium uppercase tracking-wider`;

export const menuClassNames = (active) =>
  classNames(
    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
    "cursor-pointer block px-4 py-2 text-sm"
  );

export const transitionScaleAndShowClasses = {
  as: "div",
  className: "transition-all duration-500",
  enterFrom: "transform scale-95 opacity-0 max-h-0",
  enterTo: "transform scale-100 opacity-100 max-h-fit",
  leaveFrom: "transform scale-100 opacity-100 max-h-fit",
  leaveTo: "transform scale-95 opacity-0 max-h-0"
};

export const transitionSlideFromLeftClasses = {
  as: "div",
  className: "transition-all duration-500",
  enterFrom: "-translate-x-full",
  enterTo: "translate-x-0",
  leaveFrom: "translate-x-0",
  leaveTo: "-translate-x-full"
};

export const transitionSlideFromTopClasses = {
  as: "div",
  className: "transition-all duration-500",
  enterFrom: "-translate-y-full", // Starts off-screen at the top
  enterTo: "translate-y-0", // Ends at the default position
  leaveFrom: "translate-y-0", // Starts at the default position
  leaveTo: "-translate-y-full" // Exits off-screen at the top
};

export const sectionClasses = "rounded-md bg-white pt-4 pb-0 px-4 shadow";

export const sectionHeaderClasses =
  "text-base font-semibold text-gray-900 pl-1";

export const sectionTopBarClasses =
  "bg-gray-50 border-t border-b border-gray-200 mt-4 sticky top-0 z-10";

export const suggestionBackgroundClasses =
  "bg-amber-50 rounded-md px-6 py-2 mb-2";

export const tooltipClasses =
  "bg-neutral-600 text-white text-sm px-2 py-1 rounded box-border w-max max-w-screen-sm";
